/* import __COLOCATED_TEMPLATE__ from './enforce-sso-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();